import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const JobbaHosOss = lazy(() => import("@/pages/info/JobbaHosOss"));

export const Route = createFileRoute("/jobba-hos-oss")({
  head: () => seoHead("/jobba-hos-oss", { description: "Vi växer snabbt och söker drivna kollegor inom utveckling, produkt, content och kundtjänst." }),
  component: () => <JobbaHosOss />,
});
